// Компонента принимает тип const enum STATUS пример использования => <StatusType roles={[STATUS.TO_REWORK]}>
import React, { PropsWithChildren } from "react";
import { APPLICATION_BANK_STATUS } from "./types";
import { getStatusesWithoutDisabled } from "./helpers";

// Вспомогательный интерфейс для разрешенных статусов
interface allowApplicationBankStatusGuard {
  allowedStatuses: APPLICATION_BANK_STATUS[];
  disabledStatuses?: never;
}
// Вспомогательный интерфейс для запрещенных статусов
interface disableApplicationBankStatusGuard {
  disabledStatuses: APPLICATION_BANK_STATUS[];
  allowedStatuses?: never;
}
/**Тип пропсов для проверки статуса
 * Можно передавать только разрешенные или только запрещенные статусы
 */
type ApplicationBankStatusGuardProps = {
  status?: APPLICATION_BANK_STATUS;
} & (allowApplicationBankStatusGuard | disableApplicationBankStatusGuard);

/** Guard по статусам основных заявок. */
export const ApplicationBankStatusGuard = ({
  status,
  allowedStatuses,
  disabledStatuses,
  children,
}: PropsWithChildren<ApplicationBankStatusGuardProps>) => {
  if (!status) {
    return null;
  }
  if (allowedStatuses && allowedStatuses.includes(status)) {
    return <>{children}</>;
  }

  if (
    disabledStatuses &&
    getStatusesWithoutDisabled(disabledStatuses).includes(status)
  ) {
    return <>{children}</>;
  }

  return null;
};
